import { render, staticRenderFns } from "./LKPublicationsFormdataTableEditModal.vue?vue&type=template&id=e79901c4&"
import script from "./LKPublicationsFormdataTableEditModal.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsFormdataTableEditModal.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsFormdataTableEditModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VExpandTransition,VIcon,VImg,VRow})
